import { useEffect } from 'react'
import { WarningIcon } from '@weblite/icons'
import { styled } from '@mui/material/styles'
import { fullReload } from '$helper/functions/fullReload'
import { SecondaryButton } from '$common/buttons/secondary-button'
import { ErrorPage } from '$comp/error-pages/error-page'
import { useFakeProgressWithOnlineStatus } from '$hooks/use-fake-progress-with-online-status'
import { t } from '$i18n'

const ErrorIconWrapper = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 140px;
  height: 140px;
  background-color: ${({ theme }) => theme.palette.secondary100};
  border-radius: 50%;
`

function ErrorIcon() {
  return (
    <ErrorIconWrapper>
      <WarningIcon
        sx={{ width: '64px', height: '64px', color: 'secondary700' }}
      />
    </ErrorIconWrapper>
  )
}

interface ForceUpdateWebDialogApi {
  finishProgress: () => unknown
}

export const forceUpdateWebDialogApi: ForceUpdateWebDialogApi = {
  finishProgress() {},
}

export function ForceUpdateWebDialog({
  isOpen,
  cb,
}: {
  isOpen: boolean
  cb?: () => Promise<unknown>
}) {
  const { percent, updateIsOver, finishProgress } =
    useFakeProgressWithOnlineStatus(cb)

  useEffect(() => {
    forceUpdateWebDialogApi.finishProgress = finishProgress
  }, [finishProgress])

  return (
    <ErrorPage
      isOpen={isOpen}
      icon={<ErrorIcon />}
      title={t('forceUpdateWeb.title')}
      description={t('forceUpdateWeb.description')}
      actionButtons={
        <SecondaryButton
          text={t('forceUpdateWeb.actionButton')}
          onClick={fullReload}
          fullWidth
          disabled={!updateIsOver}
        />
      }
      progress={percent}
    />
  )
}
